<div class="public-shell">
	<router-outlet></router-outlet>
	<!-- Loading veil (full screen here — public routes have no app chrome). -->
	<app-loading-gk></app-loading-gk>
</div>
